import { DTODocumentationAnalyticsRequest, DTODocumentationPageAnalyticsResponse } from "../../dto";
import { RequestExecutor } from "../../transport/request-executor";

export class DesignSystemAnalyticsEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  get(designSystemId: string, versionId: string, body: DTODocumentationAnalyticsRequest) {
    return this.requestExecutor.json(
      `/design-systems/${designSystemId}/versions/${versionId}/documentation/analytics`,
      DTODocumentationPageAnalyticsResponse,
      { method: "POST", body }
    );
  }
}
